import { encodeFilter } from '../query/codec'
import type { ImportBatch } from './types'

/** The register page of the records an import created, filtered on that import. */
export function importedRecordsPath(batch: Pick<ImportBatch, 'id' | 'mode'>): string {
  const filter = encodeFilter({
    version: 2,
    quick: [],
    groups: [[{ property: 'import_batch', operator: 'is_any_of', value: [batch.id] }]],
  })
  return `/relaties/${batch.mode}?f=${filter}`
}
